import { render, staticRenderFns } from "./viewDetial.vue?vue&type=template&id=35eca482&scoped=true&"
import script from "./viewDetial.vue?vue&type=script&lang=js&"
export * from "./viewDetial.vue?vue&type=script&lang=js&"
import style0 from "./viewDetial.vue?vue&type=style&index=0&id=35eca482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eca482",
  null
  
)

export default component.exports